var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Electricity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.056 1.504a.31.31 0 0 0-.012.022L8.306 5.47h4.192a.311.311 0 0 1-.075.11l-7.46 8.325L7.051 7.91H3.49l.006-.021.018-.046.018-.048c.02-.061.023-.135.06-.161l2.195-5.876z",
    stroke: "#FDA805"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Electricity);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-electricity.ad0401ff.svg";
export { ForwardRef as ReactComponent };